import React from 'react';
import PropTypes from 'prop-types';

function LabelContainer({
    label,
    value,
    labelStyle
}) {
    return (
        <div className="ObjLabels">
            {label && <span className="ViewTableObjDesc" >{label}&nbsp;</span>}
            <span className="ViewTableObjName" style={labelStyle}> {value} </span>
        </div>
    );
}

LabelContainer.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string
}

export default LabelContainer;